export default {"src":"/_next/static/media/reconnaissance.3424eb04.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};